export default function(Vue) {
  Vue.auth = {
    settokenAdmin: (tokenAdmin, expirationAdmin) => {
      localStorage.setItem("tokenAdmin", tokenAdmin);
      localStorage.setItem("expirationAdmin", expirationAdmin);
    },
    gettokenAdmin: () => {
      const tokenAdmin = localStorage.getItem("tokenAdmin");
      const expirationAdmin = localStorage.getItem("expirationAdmin");

      if (!tokenAdmin || !expirationAdmin) return null;

      if (Date.now() > parseInt(expirationAdmin)) {
        this.destroytokenAdmin();
        return null;
      } else return tokenAdmin;
    },
    getUser: () => {
      const userName = localStorage.getItem("userName");
      return userName;
    },
    destroytokenAdmin: () => {
      localStorage.removeItem("tokenAdmin");
      localStorage.removeItem("expirationAdmin");
    },

    isAuthenticated: () => {
      var tokenAdmin = localStorage.getItem("tokenAdmin");
      var expirationAdmin = localStorage.getItem("expirationAdmin");

      if (!tokenAdmin || !expirationAdmin) return false;

      if (Date.now() > parseInt(expirationAdmin)) {
        localStorage.removeItem("tokenAdmin");
        localStorage.removeItem("expirationAdmin");
        return false;
      } else return true;

      // if (this.gettokenAdmin())
      //     return true
      // else
      //     return false
    }
  };
  Object.defineProperties(Vue.prototype, {
    $auth: {
      get: () => {
        return Vue.auth;
      }
    }
  });
}
